import React from 'react'
import { IconProps } from '.'

export const TrashCanIcon = (props: IconProps) => {
    return (
   
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            color="#394B59"
            {...props}
        >
            <path
                d="M13.5 3H2.5C2.30109 3 2.11032 3.07902 1.96967 3.21967C1.82902 3.36032 1.75 3.55109 1.75 3.75C1.75 3.94891 1.82902 4.13968 1.96967 4.28033C2.11032 4.42098 2.30109 4.5 2.5 4.5H2.75V13C2.75 13.3315 2.8817 13.6495 3.11612 13.8839C3.35054 14.1183 3.66848 14.25 4 14.25H12C12.3315 14.25 12.6495 14.1183 12.8839 13.8839C13.1183 13.6495 13.25 13.3315 13.25 13V4.5H13.5C13.6989 4.5 13.8897 4.42098 14.0303 4.28033C14.171 4.13968 14.25 3.94891 14.25 3.75C14.25 3.55109 14.171 3.36032 14.0303 3.21967C13.8897 3.07902 13.6989 3 13.5 3ZM11.75 12.75H4.25V4.5H11.75V12.75ZM4.75 1.25C4.75 1.05109 4.82902 0.860322 4.96967 0.71967C5.11032 0.579018 5.30109 0.5 5.5 0.5H10.5C10.6989 0.5 10.8897 0.579018 11.0303 0.71967C11.171 0.860322 11.25 1.05109 11.25 1.25C11.25 1.44891 11.171 1.63968 11.0303 1.78033C10.8897 1.92098 10.6989 2 10.5 2H5.5C5.30109 2 5.11032 1.92098 4.96967 1.78033C4.82902 1.63968 4.75 1.44891 4.75 1.25Z"
                fill="currentcolor"
            />
        </svg>
    )
}
